// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + chunkId + "--" + {"2297":"d471b02","3318":"706d78c","8816":"55c9783"}[chunkId] + ".js";
};